import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SMSTextService {
  constructor(private http:HttpClient) { }


  GetRecord():Observable<Array<General_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/SMS_Text").pipe(
      map(data=>{
        return data as Array<General_Interface>
      })
    )
  }

  GetSingle(id:Number):Observable<General_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/SMS_Text/GetSingle?id="+id).pipe(
      map(data=>{
        return data as General_Interface
      })
    )
  }

  AddSMS_Text(model: General_Interface):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      dsc:model.code,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/SMS_Text/Add",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  EditSMS_Text(model: General_Interface):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      dsc:model.code,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/SMS_Text/Edit",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  DeleteSMS_Text(id:number):Observable<General_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/SMS_Text/Delete?id="+id).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  }
